/**
 * Report reasons and mock report history data.
 *
 * Used in the Report History page to display user's submitted reports.
 */

/**
 * Categories of content that can be reported.
 */
export const CONTENT_TYPES = [
  'Stream',
  'Username',
  'Message',
  'Comment',
  'Account',
];

/**
 * Reasons for reporting content — based on common platform guidelines.
 */
export const REPORT_REASONS = [
  'Sexual Content',
  'Violent Content',
  'Harassment',
  'Hate Speech',
  'Spam',
  'Misinformation',
  'Deceptive Activity',
  'Impersonation',
  'Copyright Infringement',
  'Privacy Breach',
  'Illegal Activity',
  'Self-Harm',
];

/**
 * Possible statuses for a report.
 */
export const REPORT_STATUSES = {
  IN_PROGRESS: 'In Progress',
  COMPLIANT: 'Deemed Compliant',
  NON_COMPLIANT: 'Deemed Non-Compliant',
};

/**
 * Status color mapping for report outcomes.
 */
export const REPORT_STATUS_COLORS = {
  'In Progress': '#4a8a9e',
  'Deemed Compliant': '#22c55e',
  'Deemed Non-Compliant': '#ef4444',
};

/**
 * Mock report history data.
 */
export const MOCK_REPORTS = [
  { id: 1, account: 'DougDoug', content: 'Stream', reason: 'Sexual Content', status: 'Deemed Compliant' },
  { id: 2, account: 'Jenny Talia', content: 'Username', reason: 'Sexual Content', status: 'In Progress' },
  { id: 3, account: 'randouser', content: 'Message', reason: 'Deceptive Activity', status: 'In Progress' },
  { id: 4, account: 'MisterPeanutButter', content: 'Comment', reason: 'Spam', status: 'Deemed Non-Compliant' },
  { id: 5, account: 'Markimoo', content: 'Account', reason: 'Impersonation', status: 'Deemed Non-Compliant' },
  { id: 6, account: 'OscarTheCouch', content: 'Stream', reason: 'Violent Content', status: 'Deemed Compliant' },
  { id: 7, account: 'kermit', content: 'Stream', reason: 'Copyright Infringement', status: 'In Progress' },
  { id: 8, account: 'Karen', content: 'Stream', reason: 'Misinformation', status: 'Deemed Non-Compliant' },
  { id: 9, account: 'bigbord', content: 'Stream', reason: 'Illegal Activity', status: 'In Progress' },
  { id: 10, account: 'bERT', content: 'Stream', reason: 'Privacy Breach', status: 'Deemed Non-Compliant' },
  { id: 11, account: 'badperson', content: 'Comment', reason: 'Hate Speech', status: 'Deemed Non-Compliant' },
  { id: 12, account: 'aaaaaaaaa', content: 'Message', reason: 'Harassment', status: 'Deemed Compliant' },
  { id: 13, account: 'generic name', content: 'Stream', reason: 'Self-Harm', status: 'Deemed Compliant' },
];
